import { localizationEnUsSearch, routerPageSearch } from "./search";
import {
  localizationEnUsKnowledgeBase,
  routerPageKnowledgeBase,
} from "./knowledge-base";
import {
  localizationEnUsKnowledgeBaseArticle,
  routerPageKnowledgeBaseArticle,
} from "./knowledge-base-article";
import { localizationEnUsFaq, routerPageFaq } from "./faq";
import { localizationEnUsCases, routerPageCases } from "./cases";
import { localizationEnUsCaseView, routerPageCaseView } from "./case-view";

export const localizationEnUsSupport = {
  ...localizationEnUsSearch,
  ...localizationEnUsFaq,
  ...localizationEnUsKnowledgeBase,
  ...localizationEnUsKnowledgeBaseArticle,
  ...localizationEnUsCases,
  ...localizationEnUsCaseView,
};

export const routersPageSupport = [
  routerPageFaq,
  routerPageKnowledgeBase,
  routerPageKnowledgeBaseArticle,
  routerPageCases,
  routerPageCaseView,
  routerPageSearch,
];
